@if (data$ | async; as data) {
  <div class="content {{ data.styleClasses }}">
    @if (data.transparentBox) {
      <app-gg-transparent-box [color]="data.cssColorClass" [compData]="data.transparentBox"> </app-gg-transparent-box>
    }
    @if (data.button && data.button.locUrl) {
      <cx-generic-link
        [target]="getTarget(data.button.target)"
        [class]="'btn-hisense'"
        [url]="data.button.locUrl"
        [ariaLabel]="
          data.button.linkName +
          (data.transparentBox?.title ? ' ' + ('common.about' | cxTranslate) + ' ' + data.transparentBox?.title : '') +
          (data.button.target === '_blank' ? ' (opens in new tab)' : '')
        "
        role="button"
      >
        {{ data.button.linkName }}
      </cx-generic-link>
    }
    @if (data.button2 && data.button2.locUrl) {
      <cx-generic-link
        [target]="getTarget(data.button2.target)"
        [class]="'btn-hisense'"
        [url]="data.button2.locUrl"
        [ariaLabel]="
          data.button2.linkName +
          (data.transparentBox?.title ? ' ' + ('common.about' | cxTranslate) + ' ' + data.transparentBox?.title : '') +
          (data.button2.target === '_blank' ? ' (opens in new tab)' : '')
        "
        role="button"
      >
        {{ data.button2.linkName }}
      </cx-generic-link>
    }
  </div>
  @if (data.button && data.button.locUrl) {
    <cx-generic-link
      [target]="getTarget(data.button.target)"
      [tabindex]="-1"
      [url]="data.button.locUrl!"
      [attr.aria-hidden]="true"
      class="banner-link"
    >
      <ng-container *ngTemplateOutlet="banner; context: { $implicit: data }"></ng-container>
    </cx-generic-link>
  } @else {
    <ng-container *ngTemplateOutlet="banner; context: { $implicit: data }"></ng-container>
  }
}

<ng-template #banner let-data>
  <div class="banner">
    @if (data.image) {
      <app-gg-media-with-mobile-media
        [container]="data.image"
        [mobileContainer]="data.mobileImage"
        [loading]="loadingStrategy"
        [attr.title]="data.image?.altText || 'Carousel image'"
      ></app-gg-media-with-mobile-media>
    }
  </div>
</ng-template>
